import { render, staticRenderFns } from "./DepositRuleForm.vue?vue&type=template&id=7821f2bd"
import script from "./DepositRuleForm.vue?vue&type=script&lang=ts"
export * from "./DepositRuleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports